import { useEffect } from "react";
import { segmentLoader } from "./segmentLoader";

export const Segment = () => {
  useEffect(() => {
    // don't run in tests
    if (typeof window === "undefined") {
      return;
    }

    // don't run if no api key
    // @ts-ignore
    const segmentId = SEGMENT_ID;
    if (!segmentId) {
      return;
    }

    // load analytics.js async
    // @ts-ignore
    if (!SEGMENT_IGNORED_DOMAINS.includes(window.location.hostname)) {
      segmentLoader(segmentId);
    }
  }, []);

  return null;
};
